<template>
  <div class="Stylist">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Estilistas registrados</p>
        <div class="c-i-c">
          <p class="o-b t-u-c">Total estilistas: {{totaluser}}</p>
        </div>
         <div class="b-c">
          <p class="o-b sub-t">Buscar nombre, apellido, correo o teléfono</p>
          <div class="m-top form-search-m" >
            <div class="input-group">
              <div class="c-f-g">
                <img class="i-f-s" src="@/assets/images/search.png" alt="src">
              </div>
              <input v-model="searchText" @keyup.enter="search" type="text" class="form-control i-s c-f-g" placeholder="Ingresa los términos de búsqueda" aria-label="Username" aria-describedby="basic-addon1">
              <button v-on:click="search" class="btn-f but-g " id="basic-addon1">Buscar</button>
            </div>
            
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Estilistas registrados</p>
          <div class="text-center m-top" v-if="userStylelist.length == 0">Sin resultados</div>
          <div class="text-center" v-if="userStylelist.length > 0">
            <div v-bind:class="{'c-t-info-h-active': activeUR}" class="c-t-info">
              <table class="table table-light m-top">
                <thead>
                  <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Correo electrónico</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(o, e) in userStylelist" :key="e">
                    <td>{{o.fullname}}</td>
                    <td>{{o.email}}</td>
                    <td>{{o.phone}}</td>
                    <td>
                       <router-link :to="{name: 'DetailS', params:{id: o.id} }" >
                        <button class="btn-actions">
                          <img src="@/assets/images/acciones.png" alt="acciones" />
                        </button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>

import User from '../parse/models/User'

export default {
  name: 'Stylist',
  data () {
    return {
      totaluser: 0,
      activeUR: true,
      searchText: "",
      userStylelist: []
    }
  },
  beforeMount() {
    var f = 0;
    User.loadStylelist().then((user) => {
      console.log(user)
      this.userStylelist = user
    })
    User.countStylist().then((user) => {
      this.totaluser = user
    })

    
  },
  methods: {
    convertir(){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres convertir al usuario?',
        type: 'warning',
        confirmButtonText: 'Convertir',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Usuario convertido', 'success')
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },
    bloquear(){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres bloquear al usuario?',
        type: 'warning',
        confirmButtonText: 'Bloquear',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Usuario bloqueado', 'success')
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },
    comentario(){
      this.$swal({
        title: 'Comentario',
        text: ' "Quiero a Mari Carmen" ',
        showCloseButton: false,
      })
    },
    search(){
      console.log("Buscando");
      User.searchStylelist(this.searchText).then((user) => {
        console.log("Response: " + user)
        this.userStylelist = user
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .c-t-info{
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }

  .c-t-info-h-active{
    height: auto;
    max-height: 600px;

  }

  /* USER INFO */
  .img_user{
    width: 138px;
    height: 138px;
    border-radius: 70px;
    float: left;
    margin-right: 20px;
  }

  .info-u{
    display: inline;
  }

  .info-ac button{
    display: inline;
  }

  table tbody tr{
    background: #F3F3F3;
  }

  .but-r{
    background: #E96369;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-r:hover{ 
    background: rgb(231, 76, 84);
  }

  .but-c{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 270px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-c:hover{ 
    background: #14fc78;
  }
  
  

  .m-r{
    margin-right: 50px;
  }

  .dropdown-menu{
    width: 120px;
  }

  /* Container */
  
  .content-info{
    margin-left: 310px;
    margin-right: 50px;
  }

  .c-i-c{
    width: 210px;
    height: 51px;
    background: #000;
    text-align: center;
    border-radius: 20px;
  }

  .t-u-c{
    padding-top: 14px;
    color: #fff;
    font-size: 16px;
  }

  .b-c {
    margin-right: 50px;
    margin-top: 37px;
    border: 1px solid #f6f6f6;
    -webkit-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    -moz-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    padding: 15px;
  }

  .sub-t{
    font-size: 18px;
    display: inline;
  }

  .i-f-s{
    width: 25px;
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .c-f-g{
    background: #f3f3f3;
    border: none;
    padding: 2px;
    height: 40px;
  }

  .but-g{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
    margin: 0 0 0 20px;
  }
  .but-g:hover{ 
    background: #14fc78;
  }

  .but-b{
    background: #000;
    color: #fff;
    border: 0;
    width: 200px;
    height: 40px;
    border-radius: 10px;
  }
  .but-b:hover{ 
    background: rgb(27, 27, 27);
  }


  .btn-f{
    margin: 0 40px 0 20px;
  }

  .f-r{
    float: right;
  }

  .s-o{
    background: #f3f3f3;
    border: none;
    font-family: "Open regular";
    font-size: 16px;
    padding: 5px;
    width: 200px;
  }

  .s-o option{
    padding: 5px;
  }

  .table{
    border: 1px solid #f6f6f6;
    text-align: center;
  }
  .btn-actions{
    background: #f6f6f6;
    border: none;
  }

</style>
